import styled from 'styled-components';
import Wrapper from 'gatsby-theme-wordpress/src/components/highlighted-pages/wrapper';

export default styled(Wrapper)`
  margin-top: 30px;
`;
